import { combineReducers, createStore, compose, applyMiddleware } from 'redux'
import { routeReducer, syncHistory } from 'react-router-redux'
import { hashHistory } from 'react-router'
import thunk from 'redux-thunk'
import {forms, FormState} from '../reducers'
import { createLogger } from 'redux-logger'
import { composeWithDevTools } from "redux-devtools-extension";
//import {Store} from "react-redux";
import {alertModal, ModalState} from "../reducers/alertModal";

export type RootState = {
    routing: any,
    forms: FormState,
    modal: ModalState
}
const logger = createLogger()
const reduxRouterMiddleware = syncHistory(hashHistory);
const rootReducer = combineReducers<RootState>({
    routing: routeReducer,
    forms: forms,
    modal: alertModal,
})
let store;
let middlewares: any;

if(process.env.NODE_ENV === 'production') {
    middlewares = applyMiddleware(thunk, reduxRouterMiddleware);
    store = createStore(
        rootReducer,
        composeWithDevTools(middlewares)
    );
} else {
    middlewares = applyMiddleware(thunk, reduxRouterMiddleware, logger);
    store = createStore(
        rootReducer,
        composeWithDevTools(middlewares)
    );
}

export { store };


// WEBPACK FOOTER //
// ./src/store/index.ts